import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from './loader.service';
import { environment as config } from '../../environments/environment';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  providers: [LoaderService]
})
export class LoaderComponent implements OnInit {
  private subscription: Subscription;
  show = false;

  constructor (private loaderService: LoaderService) {}

  ngOnInit() {
    this.subscription = LoaderService.loaderSubject
     .subscribe((state: any) => {
       this.show = state.show;
     });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/loader/loader.component.ts